export enum IssueState {
    backlog = 1,
    queued,
    assigned,
    accepted,
    testing,
    commentsWaiting,
    criticalWaiting,
    available,
    completed,
    stub,
    archive,
}

export const getIssueStateNameRu = (state: IssueState) => {
    switch (state) {
        case IssueState.backlog: return 'Беклог';
        case IssueState.queued: return 'В очереди';
        case IssueState.assigned: return 'Назначена';
        case IssueState.accepted: return 'В работе';
        case IssueState.testing: return 'Тестирование';
        case IssueState.commentsWaiting: return 'Ждет комментариев';
        case IssueState.criticalWaiting: return 'Отложена в пользу критической';
        case IssueState.available: return 'Доступна для клиента';
        case IssueState.completed: return 'Выполнена';
        case IssueState.stub: return 'Создана';
        case IssueState.archive: return 'Архив';
    }
}